import '@hotwired/turbo-rails'

window.Prism = window.Prism || {}
window.Prism.manual = true

import './controllers'
import './component_controllers'
import './turbo_streams/redirect'
import './turbo_streams/dispatch_event'
import './turbo_confirm'
